

export const ourCarriersBannerContent = (

  <div className='
            text-2xl
      '>
    Our Health Insurance Carriers
  </div>
)